import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import track from 'utils/track';
import { getCoachAiName } from 'utils/i18n';
import { MINDSET_ID, addMindsetAIIfRequired } from 'utils/mindsetAI';
import useSearchParameter from 'hooks/useSearchParameter';
import { useFetchMindsetSettings } from 'actions/userProfile';
import Box from 'components/Box';
import Card from 'components/Card';
import CenterContent from 'components/CenterContent';
import CoachAiAvatar from 'components/Avatar/CoachAIAvatar';
import Flex from 'components/Flex';
import Landmark from 'components/Landmark';
import PageBackLink from 'components/PageBackLink';
import PageSection from 'components/PageSection';
import PageTitle from 'components/PageTitle';
import Spinner from 'components/Spinner';
import { HOME_ROUTE } from '../../../routes';
import ErrorScreen from '../errors/ErrorScreen';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function CoachAI() {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState('loading'),
    _useState2 = _slicedToArray(_useState, 2),
    mindsetLoadingStatus = _useState2[0],
    setMindsetLoadingStatus = _useState2[1];
  var _useSearchParameter = useSearchParameter('q'),
    _useSearchParameter2 = _slicedToArray(_useSearchParameter, 1),
    q = _useSearchParameter2[0];
  useEffect(function () {
    function addMindset() {
      return _addMindset.apply(this, arguments);
    }
    function _addMindset() {
      _addMindset = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _t;
        return _regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 1;
              return addMindsetAIIfRequired({
                render: true,
                search: q === null || q === void 0 ? void 0 : q.toString()
              });
            case 1:
              _context.next = 3;
              break;
            case 2:
              _context.prev = 2;
              _t = _context["catch"](0);
              console.error('Mindset:', _t);
              setMindsetLoadingStatus('error');
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 2]]);
      }));
      return _addMindset.apply(this, arguments);
    }
    addMindset();
  }, [q]);
  useEffect(function () {
    // Ideally I would update this row when the component unmounts, but for now I'm creating 2 entries in case the browser is closed
    track('featureUsage', 'mindset');
    var openTime = Date.now();
    return function () {
      var duration = Date.now() - openTime;
      var durationInSeconds = Math.round(duration / 1000);
      track('featureUsage', 'mindset', durationInSeconds);
    };
  }, []);
  return /*#__PURE__*/_jsxs(PageSection, {
    children: [/*#__PURE__*/_jsx(PageBackLink, {
      fallback: HOME_ROUTE,
      mb: "xs"
    }), /*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      mb: "s",
      gap: "xs",
      children: [/*#__PURE__*/_jsx(CoachAiAvatar, {
        size: "big"
      }), /*#__PURE__*/_jsx(PageTitle, {
        size: "large",
        children: getCoachAiName()
      })]
    }), /*#__PURE__*/_jsxs(Card, {
      position: "relative",
      height: "70vh",
      pb: "m",
      children: [mindsetLoadingStatus === 'loading' && /*#__PURE__*/_jsx(CenterContent, {
        fillParent: true,
        children: /*#__PURE__*/_jsx(Spinner, {})
      }), mindsetLoadingStatus === 'error' && /*#__PURE__*/_jsx(CenterContent, {
        fillParent: true,
        children: /*#__PURE__*/_jsx(Landmark, {
          icon: "logout",
          children: t('error_could_not_load_data')
        })
      }), /*#__PURE__*/_jsx(Box, {
        height: "100%",
        id: MINDSET_ID,
        onLoadCapture: function onLoadCapture() {
          return setMindsetLoadingStatus('success');
        }
      })]
    })]
  });
}
function CoachAiAccessWrapper(_ref) {
  var children = _ref.children;
  var _useFetchMindsetSetti = useFetchMindsetSettings(),
    hasMindsetAgent = _useFetchMindsetSetti.hasMindsetAgent,
    isLoading = _useFetchMindsetSetti.isLoading;
  if (isLoading) {
    return /*#__PURE__*/_jsx(CenterContent, {
      fillParent: true,
      children: /*#__PURE__*/_jsx(Landmark, {
        icon: "spinner"
      })
    });
  }
  if (hasMindsetAgent) {
    return children;
  }
  return /*#__PURE__*/_jsx(ErrorScreen, {});
}
function ProtectedCoachAi() {
  return /*#__PURE__*/_jsx(CoachAiAccessWrapper, {
    children: /*#__PURE__*/_jsx(CoachAI, {})
  });
}
export default ProtectedCoachAi;